'use client';

import dynamic from 'next/dynamic';

const CookieConsentProvider = dynamic(
  () =>
    import('./CookieConsent').then((mod) => ({
      default: mod.CookieConsentProvider,
    })),
  {
    ssr: false,
    loading: () => null,
  }
);

/**
 * Mounts the vanilla-cookieconsent manager client-side only (the library
 * touches document/window at init, so ssr:false stays).
 *
 * MUST stay childless: wrapping `{children}` in an ssr:false component makes
 * the ENTIRE subtree render as the `loading` fallback (null) during SSR —
 * that shipped an empty <body> for every page and hid the server-rendered
 * JSON-LD from crawlers. The consent manager doesn't provide any context the
 * app consumes; it only runs CookieConsent.run() and renders its own modal.
 */
export default function CookieProviders() {
  return <CookieConsentProvider />;
}
